import React, { Component } from "react";

class FotoField extends Component {
    state = {
        foto: false,
    };
    constructor(props) {
        super(props);

        this.foto = React.createRef();
    }
    componentDidMount() {
        this.setState({
            foto: this.props.foto,
        });
    }
    onChangeFoto = (e) => {
        const reader = new FileReader();

        const that = this;

        reader.onload = (e) => {
            that.setState({
                foto: e.target.result,
            });
        };

        if (e.target.files[0]) {
            reader.readAsDataURL(e.target.files[0]);
        } else {
            this.setState({
                foto: false,
            });
        }
    };
    removeFoto = () => {
        this.foto.current.value = null;
        this.setState({
            foto: false,
        });
    };
    render() {
        const { foto } = this.state;
        const { name, fotoCed } = this.props;
        return (
            <div className='foto-container'>
                {!fotoCed && (
                    <div>
                        <input
                            name={name}
                            type='file'
                            style={{
                                display: foto ? "none" : "block",
                            }}
                            ref={this.foto}
                            accept='image/png, image/jpeg'
                            onChange={this.onChangeFoto}
                        />
                        {foto && <img src={foto} alt='Foto' />}
                    </div>
                )}
                {fotoCed && (
                    <div>
                        <input type='hidden' name='fotoCed' value={fotoCed} />
                        <img
                            src={`data:image/jpeg;base64,${fotoCed}`}
                            alt={name}
                        />
                    </div>
                )}
                {foto && (
                    <div>
                        <input
                            type='hidden'
                            name={`${name}`}
                            value={foto ? foto : ""}
                        />
                    </div>
                )}
                {foto && (
                    <button type='button' onClick={this.removeFoto}>
                        X
                    </button>
                )}
            </div>
        );
    }
}

export default FotoField;
